import { therapyPlanningAction } from '../../actions/constant';

const {
  GET_FIVE_DAY_ARD_WINDOW_SUCCESS,
  GET_FIVE_DAY_ARD_WINDOW_FAILURE,
  GET_FIVE_DAY_ARD_WINDOW_LOADING,
  GET_FIVE_DAY_ARD_WINDOW_RESET,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const getFiveDayArdWindowReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_FIVE_DAY_ARD_WINDOW_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: true,
      };
    }

    case GET_FIVE_DAY_ARD_WINDOW_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };
    case GET_FIVE_DAY_ARD_WINDOW_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_FIVE_DAY_ARD_WINDOW_RESET:
      return intitialstate;

    default:
      return state;
  }
};
